// ── Intro screen with wave loader ──
(function(){
  document.body.classList.add('intro-active');
  const intro = document.getElementById('intro');
  const num = document.getElementById('intro-num');
  const fill = document.getElementById('intro-fill');
  const barContainer = document.getElementById('intro-progress-bar');
  const waveCanvas = document.getElementById('intro-wave-canvas');
  const boatEl = document.getElementById('intro-boat');

  let pct = 0;
  let wt = 0;
  let waveRaf = null;

  // Setup canvas
  function resizeCanvas(){
    if(!waveCanvas || !barContainer) return;
    waveCanvas.width = barContainer.offsetWidth;
    waveCanvas.height = barContainer.offsetHeight;
  }
  resizeCanvas();

  // Show boat immediately at 0 position
  if(boatEl && barContainer){
    boatEl.style.left = '0px';
    boatEl.style.opacity = '1';
  }

  // Animate wave inside the fill bar
  function animateWave(){
    if(!waveCanvas || !barContainer) return;
    const ctx = waveCanvas.getContext('2d');
    const W = waveCanvas.width;
    const H = waveCanvas.height;
    ctx.clearRect(0, 0, W, H);

    // Wave shape
    ctx.beginPath();
    for(let x = 0; x <= W; x += 2){
      const y = H * 0.4 + Math.sin((x * 0.045) + wt) * 3 + Math.cos((x * 0.028) + wt * 0.8) * 2;
      x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
    }
    ctx.lineTo(W, H); ctx.lineTo(0, H); ctx.closePath();
    const grad = ctx.createLinearGradient(0, 0, 0, H);
    grad.addColorStop(0, 'rgba(126,207,255,0.3)');
    grad.addColorStop(1, 'rgba(13,34,53,0.95)');
    ctx.fillStyle = grad;
    ctx.fill();

    // Wave highlight line
    ctx.beginPath();
    for(let x = 0; x <= W; x += 2){
      const y = H * 0.4 + Math.sin((x * 0.045) + wt) * 3 + Math.cos((x * 0.028) + wt * 0.8) * 2;
      x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
    }
    ctx.strokeStyle = 'rgba(126,207,255,0.6)';
    ctx.lineWidth = 1;
    ctx.stroke();

    // Move boat to leading edge
    if(boatEl && barContainer){
      const barW = barContainer.offsetWidth;
      const boatX = (pct / 100) * barW;
      const bobY = Math.sin(wt * 1.2) * 2;
      const rot = Math.sin(wt * 0.9) * 3;
      boatEl.style.left = boatX + 'px';
      boatEl.style.transform = `translate(-50%, calc(-50% + ${bobY}px)) rotate(${rot}deg)`;
    }

    wt += 0.04;
    waveRaf = requestAnimationFrame(animateWave);
  }
  animateWave();

  // Loading counter
  const duration = 2800;
  const interval = 30;
  const steps = duration / interval;
  function easeOut(t){ return 1 - Math.pow(1-t, 3); }

  let step = 0;
  const timer = setInterval(()=>{
    step++;
    const t = step / steps;
    pct = Math.min(100, Math.round(easeOut(t) * 100));
    if(num) num.textContent = pct;
    if(fill) fill.style.width = pct + '%';
    if(pct >= 100){
      clearInterval(timer);
      setTimeout(dismissIntro, 400);
    }
  }, interval);

  function dismissIntro(){
    cancelAnimationFrame(waveRaf);
    if(intro){
      intro.classList.add('exiting');
      function finishDismiss(){
        intro.style.display = 'none';
        intro.style.opacity = '0';
        intro.style.pointerEvents = 'none';
        document.body.classList.remove('intro-active');
        document.body.classList.add('intro-done');
        const v = document.getElementById('vid0');
        if(v) v.play().catch(()=>{});
      }
      intro.addEventListener('animationend', finishDismiss, {once:true});
      setTimeout(finishDismiss, 1000);
    }
  }
})();

// ── Fishing hook cursor ──
const cur = document.getElementById('cursor');
document.addEventListener('mousemove',e=>{
  cur.style.left=e.clientX+'px';
  cur.style.top=e.clientY+'px';
});
document.querySelectorAll('a,button,.pc,.pc-btn').forEach(el=>{
  el.addEventListener('mouseenter',()=>cur.classList.add('on-link'));
  el.addEventListener('mouseleave',()=>cur.classList.remove('on-link'));
});

// ── Canvas cinematic hero ──
const canvas = document.getElementById('hero-canvas');
const ctx = canvas.getContext('2d');

function resize(){
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
}
resize();
window.addEventListener('resize',()=>{resize();draw()});

const STARS = Array.from({length:120},()=>({
  x:Math.random(), y:Math.random()*0.58,
  r:Math.random()<0.12?1.8:Math.random()<0.3?1.2:0.7,
  o:0.25+Math.random()*0.75,
  tw:Math.random()*Math.PI*2
}));

const SCENES=[
  {skyT:'#010508',skyB:'#07192e',waterT:'#041020',waterB:'#020c18',
   horizCol:'#1a4a70',moonA:0.9,starA:1.0,fogA:0.0,boatX:0.46,boatScale:1.0,
   lightCol:'rgba(255,180,60,0.12)',lightA:0.6},
  {skyT:'#020a14',skyB:'#0b2240',waterT:'#051525',waterB:'#030e1c',
   horizCol:'#0e3858',moonA:0.5,starA:0.55,fogA:0.08,boatX:0.50,boatScale:1.05,
   lightCol:'rgba(126,207,255,0.08)',lightA:0.3},
  {skyT:'#040c18',skyB:'#0f2840',waterT:'#060f1e',waterB:'#04101a',
   horizCol:'#0a2840',moonA:0.15,starA:0.18,fogA:0.22,boatX:0.54,boatScale:1.1,
   lightCol:'rgba(126,207,255,0.05)',lightA:0.1},
  {skyT:'#06101e',skyB:'#132640',waterT:'#081320',waterB:'#05101c',
   horizCol:'#112040',moonA:0.0,starA:0.0,fogA:0.4,boatX:0.58,boatScale:1.15,
   lightCol:'rgba(126,207,255,0.03)',lightA:0.0},
];

function lerp(a,b,t){return a+(b-a)*t}
function hexRgb(h){return[parseInt(h.slice(1,3),16),parseInt(h.slice(3,5),16),parseInt(h.slice(5,7),16)]}
function mixHex(h0,h1,t){
  const[r0,g0,b0]=hexRgb(h0),[r1,g1,b1]=hexRgb(h1);
  return`rgb(${Math.round(lerp(r0,r1,t))},${Math.round(lerp(g0,g1,t))},${Math.round(lerp(b0,b1,t))})`;
}
function lerpScene(s0,s1,t){
  const o={};
  Object.keys(s0).forEach(k=>{
    if(typeof s0[k]==='number') o[k]=lerp(s0[k],s1[k],t);
    else o[k]=s0[k];
  });
  return o;
}

let waveT=0,progress=0;

function getSceneData(p){
  const scaled=p*(SCENES.length-1);
  const idx=Math.min(Math.floor(scaled),SCENES.length-2);
  const t=scaled-idx;
  return{sc:lerpScene(SCENES[idx],SCENES[idx+1],t),idx,t};
}

function drawBoat(cx,cy,scale,alpha){
  ctx.save();
  ctx.globalAlpha=alpha;
  ctx.translate(cx,cy);
  ctx.scale(scale,scale);

  // Hull
  ctx.fillStyle='#0e0e0e';
  ctx.beginPath();
  ctx.moveTo(-90,0);ctx.lineTo(90,0);ctx.lineTo(70,22);ctx.lineTo(-70,22);ctx.closePath();ctx.fill();

  // Deck
  ctx.fillStyle='#151515';
  ctx.fillRect(-80,-10,160,12);

  // Cabin
  ctx.fillStyle='#111';
  ctx.fillRect(-28,-46,64,38);
  ctx.fillStyle='rgba(126,207,255,0.45)';
  ctx.fillRect(-22,-40,18,12);
  ctx.fillRect(2,-40,18,12);

  // Mast
  ctx.strokeStyle='#1e1e1e';ctx.lineWidth=2;
  ctx.beginPath();ctx.moveTo(-10,-46);ctx.lineTo(-10,-130);ctx.stroke();

  // Boom
  ctx.lineWidth=1.5;
  ctx.beginPath();ctx.moveTo(-10,-124);ctx.lineTo(50,-95);ctx.stroke();

  // Fishing rod
  ctx.strokeStyle='#333';ctx.lineWidth=1.5;
  ctx.beginPath();ctx.moveTo(48,-46);ctx.lineTo(75,-95);ctx.stroke();

  // Fishing line
  ctx.strokeStyle='rgba(200,220,255,0.2)';ctx.lineWidth=0.8;
  ctx.beginPath();ctx.moveTo(75,-95);ctx.lineTo(90,40);ctx.stroke();

  // Wake
  ctx.strokeStyle='rgba(126,207,255,0.08)';ctx.lineWidth=1;
  ctx.beginPath();ctx.moveTo(-90,10);ctx.bezierCurveTo(-140,18,-180,8,-240,14);ctx.stroke();
  ctx.beginPath();ctx.moveTo(-90,16);ctx.bezierCurveTo(-130,24,-170,16,-220,22);ctx.stroke();

  ctx.restore();
}

// ── Video switching ──
const videos = [
  document.getElementById('vid0'),
  document.getElementById('vid1'),
  document.getElementById('vid2'),
  document.getElementById('vid3'),
];
let currentVid = 0;

function switchToVideo(idx){
  if(idx === currentVid) return;
  videos[currentVid].classList.remove('active');
  videos[idx].classList.add('active');
  if(videos[idx].paused) videos[idx].play().catch(()=>{});
  currentVid = idx;
}

// Start first video
if(videos[0]) videos[0].play().catch(()=>{});

function draw(){
  const cw=canvas.width,ch=canvas.height;
  // Clear canvas fully (transparent — video shows through)
  ctx.clearRect(0,0,cw,ch);

  // Dark overlay so text is readable
  ctx.fillStyle='rgba(4,8,15,0.45)';
  ctx.fillRect(0,0,cw,ch);

  // Vignette
  const vigGrad=ctx.createRadialGradient(cw/2,ch/2,ch*0.25,cw/2,ch/2,ch*0.85);
  vigGrad.addColorStop(0,'transparent');
  vigGrad.addColorStop(1,'rgba(2,6,14,0.7)');
  ctx.fillStyle=vigGrad;
  ctx.fillRect(0,0,cw,ch);

  // Bottom fade into homepage
  const btmGrad=ctx.createLinearGradient(0,ch*0.75,0,ch);
  btmGrad.addColorStop(0,'transparent');
  btmGrad.addColorStop(1,'rgba(4,8,15,0.95)');
  ctx.fillStyle=btmGrad;
  ctx.fillRect(0,ch*0.7,cw,ch*0.3);
}

// ── Scroll hijack engine ──
const engine=document.getElementById('scroll-engine');
const homepage=document.getElementById('homepage');
const progFill=document.getElementById('prog-fill');
const scrollInd=document.getElementById('scroll-indicator');
const nav=document.getElementById('nav');

const TOTAL_SCROLL=3200;
let engineScroll=0;
let released=false;

function setScene(p){
  try{
    const si=Math.min(Math.floor(p*4),3);
    // Switch video chapter
    switchToVideo(si);
    for(let i=0;i<4;i++){
      const sp=document.getElementById('sp'+i);
      const pc=document.getElementById('pc'+i);
      if(sp) sp.classList.toggle('active',i===si);
      if(pc) pc.classList.toggle('active',i===si);
    }
    if(progFill) progFill.style.width=(p*100)+'%';
    if(scrollInd){
      if(p>0.05) scrollInd.classList.add('hidden');
      else scrollInd.classList.remove('hidden');
    }
  }catch(err){console.warn('setScene err',err);}
}

function releaseScroll(){
  if(released) return;
  released=true;
  try{
    engine.style.position='relative';
    engine.style.height='100vh';
    if(homepage) homepage.classList.add('visible');
    document.body.style.overflow='';
    document.body.style.overflowX='hidden';
    setTimeout(()=>{
      window.scrollTo({top:window.innerHeight,behavior:'smooth'});
    },80);
  }catch(err){console.warn('releaseScroll err',err);}
}

// ── Smooth chapter scroll — no locks, fully spammable ──
const CHAPTERS = 4;
let chapterFloat = 0.0;  // actual animated position (0 to 3)
let chapterTarget = 0.0; // desired position
let snapRaf = null;

function animateSnap(){
  chapterFloat += (chapterTarget - chapterFloat) * 0.1;
  if(Math.abs(chapterFloat - chapterTarget) < 0.001) chapterFloat = chapterTarget;

  progress = chapterFloat / (CHAPTERS - 1);
  engineScroll = progress * TOTAL_SCROLL;
  setScene(progress);
  draw();

  if(Math.abs(chapterFloat - chapterTarget) > 0.001){
    snapRaf = requestAnimationFrame(animateSnap);
  } else if(chapterTarget >= CHAPTERS - 1 && !released){
    setTimeout(releaseScroll, 500);
  }
}

function nudge(delta){
  if(released) return;
  // Each scroll nudges by 1 chapter — clamp between 0 and 3
  chapterTarget = Math.max(0, Math.min(CHAPTERS - 1, chapterTarget + delta));
  if(snapRaf) cancelAnimationFrame(snapRaf);
  snapRaf = requestAnimationFrame(animateSnap);
}

// Wheel — one intentional scroll = one chapter
let accumulated = 0;
let lastWheelT = 0;
let lastNudgeT = 0;
function onWheel(e){
  if(released) return;
  e.preventDefault();
  const now = Date.now();
  if(now - lastWheelT > 400) accumulated = 0;
  lastWheelT = now;
  accumulated += e.deltaY;
  if(Math.abs(accumulated) >= 200 && now - lastNudgeT > 700){
    nudge(accumulated > 0 ? 1 : -1);
    accumulated = 0;
    lastNudgeT = now;
  }
}

document.body.style.overflow='hidden';
window.addEventListener('wheel', onWheel, {passive:false});

// Touch swipe
let tStartY = 0;
document.addEventListener('touchstart', e=>{
  tStartY = e.touches[0].clientY;
}, {passive:true});
document.addEventListener('touchmove', e=>{
  if(released) return;
  try{ e.preventDefault(); }catch(err){}
}, {passive:false});
document.addEventListener('touchend', e=>{
  if(released) return;
  const dy = tStartY - e.changedTouches[0].clientY;
  if(Math.abs(dy) > 40) nudge(dy > 0 ? 1 : -1);
}, {passive:true});

window.addEventListener('scroll',()=>{
  if(!released) return;
  nav.classList.toggle('scrolled',window.scrollY>80);
});

// ── Nav & page transition handler ──
const pageTransition = document.getElementById('page-transition');

function navigateTo(url){
  if(!pageTransition) { window.location.href = url; return; }
  pageTransition.classList.add('active');
  setTimeout(()=>{ window.location.href = url; }, 350);
}

// Handle ALL nav links — both anchor links and real page URLs
document.querySelectorAll('a').forEach(a=>{
  const href = a.getAttribute('href');
  if(!href || href === '#') return;

  // Anchor link — scroll to section on same page
  if(href.startsWith('#')){
    a.addEventListener('click',e=>{
      e.preventDefault();
      const target = document.querySelector(href);
      if(!target) return;
      if(!released){
        engineScroll=TOTAL_SCROLL;
        progress=1;
        setScene(1);
        draw();
        releaseScroll();
        setTimeout(()=>{
          const top=target.getBoundingClientRect().top+window.innerHeight+window.scrollY;
          window.scrollTo({top,behavior:'smooth'});
        },350);
      } else {
        const top=target.getBoundingClientRect().top+window.scrollY-72;
        window.scrollTo({top,behavior:'smooth'});
      }
    });
    return;
  }

  // External link — open normally
  if(href.startsWith('http') && !href.includes(window.location.hostname)) return;

  // Internal page link — play transition then navigate
  a.addEventListener('click',e=>{
    e.preventDefault();
    navigateTo(href);
  });
});

// Fade in on page load (after transition)
window.addEventListener('pageshow',()=>{
  if(pageTransition) pageTransition.classList.remove('active');
});

// ── Campaign canvas (mini animated scene) ──
const cc=document.getElementById('campaign-canvas');
if(cc){
  const ccx=cc.getContext('2d');
  let ccT=0;
  function resizeCC(){
    const wrap=document.getElementById('campaign-canvas-wrap');
    if(!wrap) return;
    cc.width=wrap.offsetWidth;
    cc.height=wrap.offsetHeight;
  }
  resizeCC();
  window.addEventListener('resize',resizeCC);

  function drawCC(){
    const w=cc.width,h=cc.height;
    if(!w||!h){requestAnimationFrame(drawCC);return;}
    const skyGrad=ccx.createLinearGradient(0,0,0,h*0.5);
    skyGrad.addColorStop(0,'#020810');skyGrad.addColorStop(1,'#081830');
    ccx.fillStyle=skyGrad;ccx.fillRect(0,0,w,h*0.52);

    const wGrad=ccx.createLinearGradient(0,h*0.5,0,h);
    wGrad.addColorStop(0,'#041020');wGrad.addColorStop(1,'#020c18');
    ccx.fillStyle=wGrad;ccx.fillRect(0,h*0.5,w,h*0.5);

    // Stars
    STARS.slice(0,40).forEach(s=>{
      ccx.save();ccx.globalAlpha=s.o*0.7;ccx.fillStyle='#fff';
      ccx.beginPath();ccx.arc(s.x*w,s.y*h*0.5,s.r*0.8,0,Math.PI*2);ccx.fill();
      ccx.restore();
    });

    // Moon
    ccx.save();ccx.globalAlpha=0.8;ccx.fillStyle='#c8dff0';
    ccx.beginPath();ccx.arc(w*0.8,h*0.18,h*0.09,0,Math.PI*2);ccx.fill();
    ccx.restore();

    // Horizon
    const hgG=ccx.createLinearGradient(0,h*0.46,0,h*0.56);
    hgG.addColorStop(0,'transparent');hgG.addColorStop(0.5,'rgba(26,74,112,0.6)');hgG.addColorStop(1,'transparent');
    ccx.fillStyle=hgG;ccx.fillRect(0,h*0.44,w,h*0.14);

    // Waves
    for(let i=0;i<4;i++){
      const wy=h*0.52+(i/4)*h*0.2;
      ccx.save();ccx.globalAlpha=0.07;ccx.strokeStyle='#7ecfff';ccx.lineWidth=0.8;
      ccx.beginPath();
      for(let x2=0;x2<=w;x2+=3){
        const y2=wy+Math.sin(x2*0.02+ccT*(1+i*0.2))*2;
        x2===0?ccx.moveTo(x2,y2):ccx.lineTo(x2,y2);
      }
      ccx.stroke();ccx.restore();
    }

    // Boat (smaller)
    const bx2=w*0.42,by2=h*0.52;
    ccx.save();ccx.globalAlpha=0.9;ccx.translate(bx2,by2);ccx.scale(0.55,0.55);
    ccx.fillStyle='#0e0e0e';
    ccx.beginPath();ccx.moveTo(-90,0);ccx.lineTo(90,0);ccx.lineTo(70,22);ccx.lineTo(-70,22);ccx.closePath();ccx.fill();
    ccx.fillStyle='#151515';ccx.fillRect(-80,-10,160,12);
    ccx.fillStyle='#111';ccx.fillRect(-28,-46,64,38);
    ccx.fillStyle='rgba(126,207,255,0.4)';ccx.fillRect(-22,-40,18,12);ccx.fillRect(2,-40,18,12);
    ccx.strokeStyle='#1e1e1e';ccx.lineWidth=2;
    ccx.beginPath();ccx.moveTo(-10,-46);ccx.lineTo(-10,-110);ccx.stroke();
    ccx.lineWidth=1.5;ccx.beginPath();ccx.moveTo(-10,-106);ccx.lineTo(40,-82);ccx.stroke();
    ccx.restore();

    // Vignette
    const vigG=ccx.createRadialGradient(w/2,h/2,h*0.2,w/2,h/2,h*0.75);
    vigG.addColorStop(0,'transparent');vigG.addColorStop(1,'rgba(2,6,14,0.6)');
    ccx.fillStyle=vigG;ccx.fillRect(0,0,w,h);

    // Skull skull watermark
    ccx.save();ccx.globalAlpha=0.04;ccx.fillStyle='#7ecfff';
    ccx.font=`bold ${h*0.5}px serif`;ccx.textAlign='center';ccx.textBaseline='middle';
    ccx.fillText('☠',w*0.78,h*0.62);
    ccx.restore();

    ccT+=0.2;
    requestAnimationFrame(drawCC);
  }
  drawCC();
}

// ── Animate hero continuously ──
function animLoop(){
  try{
    draw();
  }catch(e){}
  requestAnimationFrame(animLoop);
}
try{draw();}catch(e){}
animLoop();

// ── Intersection observer for section fade-ins ──
try{
  const obsOpts={threshold:0.1,rootMargin:'0px 0px -50px 0px'};
  const obs=new IntersectionObserver(entries=>{
    entries.forEach(e=>{
      if(e.isIntersecting){
        e.target.style.opacity='1';
        e.target.style.transform='translateY(0)';
      }
    });
  },obsOpts);

  document.querySelectorAll('.stat-cell,.pc,.feat,.testi-card').forEach(el=>{
    el.style.opacity='0';
    el.style.transform='translateY(16px)';
    el.style.transition='opacity 0.6s ease, transform 0.6s ease';
    obs.observe(el);
  });

  // Stagger children on reveal
  document.querySelectorAll('.pgrid,.testi-grid,.features,.stats-row').forEach(grid=>{
    const children=grid.children;
    Array.from(children).forEach((child,i)=>{
      child.style.transitionDelay=(i*0.08)+'s';
    });
  });
}catch(e){}
